<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-top">
        <div class="footer-logo">
          <router-link :to=" { name: 'Home' } ">
            <picture>
              <source srcset="../../public/static/images/Logo.webp">
              <img src="../../public/static/images/Logo.png" alt="">
            </picture>
          </router-link>
        </div>
      </div>
      <div class="footer-middle">
        <div class="list-group">
          <router-link :to=" { name: 'Company' } ">
            Компания gid
          </router-link>
        </div>
        <div class="list-group">
          <router-link :to=" { name: 'Projects' } ">
            Проекты
          </router-link>
        </div>
        <div class="list-group">
          <router-link :to=" { name: 'Services' } ">
            Услуги
          </router-link>
        </div>
        <div class="list-group">
          <router-link :to=" { name: 'Contacts' } ">
            Контакты
          </router-link>
        </div>
      </div>
      <div class="footer-bottom">
        Gid.group 2021/ All rights reserved
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "AppFooter"
}
</script>

<style scoped lang="scss">
.footer {
  background-color: #0E0E0E;
  color: #fff;
  padding-top: 100px;
  &-top {
    margin-bottom: 40px;
   }
  &-middle {
    display: flex;
    flex-wrap: wrap;
    .list-group {
      flex: 0 0 20%;
      max-width: 20%;
      overflow: hidden;
      box-sizing: border-box;
      @media (max-width: 767.98px) {
        flex: 0 0 50%;
        max-width: 50%;
        margin-bottom: 20px;
      }
      a {
        font-weight: bold;
        font-size: 1.4rem;
        color: #FAFF09;
        margin-bottom: 15px;
      }
      ul {
        li {
          margin-bottom: 7px;
          font-weight: 300;
          font-size: 1.4rem;
          color: #F2F2F2;
          a {
            font-weight: 300;
            font-size: 1.4rem;
            color: #F2F2F2;
          }
        }
      }
    }
  }
  &-bottom {
    font-weight: 300;
    font-size: 1.4rem;
    color: #fff;
    padding: 50px 0 10px 0;
    text-align: center;
    @media (max-width: 767.98px) {
      padding: 30px 0 10px 0;
    }
  }
}
</style>
